import React, { useRef, useState } from "react";
import { IPermissionProps } from "../../../models/Login";
import Table from "./Table";
import Form from "./Form";
import { Toast } from "primereact/toast";
export interface IRFPDepartment {
  id?: number;
  department?: string;
  description?: string;
  isActive?: boolean | null;
  added_By?: number | null;
  added_At?: Date | null;
  update_By?: number | null;
  update_At?: Date | null;
}

export const EmptyRFPDepartment = {
  id: undefined,
  department: "",
  description: "",
  isActive: null,
  added_By: null,
  added_At: null,
  update_By: null,
  updated_At: null,
};

export interface IModel {
  open: boolean;
  singleData: IRFPDepartment;
}

const RFPPOCDepartmentMast = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ singleData: EmptyRFPDepartment, open: false } as IModel);
  const [reload, setReload] = useState(false);
  const toast = useRef<any>(null);
  const hideDialog = () => {
    setModal({ singleData: EmptyRFPDepartment, open: false });
  };
  return (
    <>
      <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}/>
      <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};

export default RFPPOCDepartmentMast;
